import store from '@/store';

import router from '@/router';

import { checkIsUpsellRequired } from '../helpers/check-is-upsell-required';


function goToOrderAheadCart(navigationParams = {}) {
  const { getters, dispatch } = store;

  const selectedLocation = getters['locations/selectedLocation'];

  const order = getters['orders/order'];

  const session = getters['session/session'];

  const isOrderAheadAtTable = session.orderDetails.fulfillmentType === 'dine-in';

  const isTableNumberMissing = Boolean(session.route.tableNumber) === false;

  const isTableNumberRequired = selectedLocation.features.RequireTableSelectionForOrdering;

  const isUpsellRequired = checkIsUpsellRequired(store);

  /* Note: Don't render the upsell modal again, if a user is navigating from the upsell modal to the cart. */
  const { isUpsellOverride } = navigationParams;

  if (isUpsellRequired && !isUpsellOverride) {
    dispatch('modals/openModal', { name: 'upsellModal' }, { root: true });
  }
  else if (isOrderAheadAtTable && isTableNumberRequired && isTableNumberMissing) {
    dispatch('modals/openModal', { name: 'enterTableNumberModal' }, { root: true });
  }
  else if (!selectedLocation.storeId) {
    dispatch('modals/openModal', { name: 'no-selected-location-modal' }, { root: true });
  }
  else if (!selectedLocation.isReadyForOrdering) {
    dispatch('modals/openModal', { name: 'location-currently-closed-modal' }, { root: true });
  }
  else if (order.orderItemCount === 0) {
    dispatch('modals/openModal', { name: 'empty-cart-modal' }, { root: true });
  }
  else {
    const routerPayload = {
      name: 'orderAheadCheckoutSummaryPage',
      params: { merchantId: router.currentRoute.value.params.merchantId }
    };

    router.push(routerPayload);
  }
}

export { goToOrderAheadCart };
